import { instance } from "config/axiosInstance";
import Axios from "axios";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function login({ pathname, body }) {
  return await Axios.post(baseURL + `/auth` + pathname, body, {
    withCredentials: true,
  });
}

export async function register(pathname, body) {
  return await instance({ baseURL: baseURL }).post(`/auth` + pathname, body);
}

export async function logout(pathname, queryparams) {
  return await instance({
    baseURL: baseURL,
  }).delete(`/auth` + pathname + queryparams);
}

export async function changePassword(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch(`/auth` + pathname, body);
}

export async function resetPassword(pathname, queryParams, body) {
  return await instance({
    baseURL: baseURL,
  }).patch(`/auth` + pathname + queryParams, body);
}
